let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("avPgB")).then(() => parcelRequire('3oO3p'));